import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { DOCUMENT } from "@angular/common";

import { LzLanguageService } from '../../../../services/lz-language/lz-language.service';
import { InvisibleReCaptchaComponent } from 'ngx-captcha';
import { CustomRequestService } from "../../../../services/custom-request/custom-request.service";
import { LzProductConfig } from "../../../../services/product-config/poduct-config";
import { Observable, interval, Subscription } from "rxjs";

declare var $: any;
declare var grecaptcha: any;

@Component({
  selector: 'app-lz-remind',
  template: `<div class="remind">
  <div class="lz-logo"><img src="/dist/ng2/src/assets/pl-header-assets/img/cutted-logo.png" alt=""></div>
  <h1>{{'user.signinup.remindPass' | translate}}</h1>
  <p class="remind-pass-email">{{'user.signinup.remindPassEmail' | translate}}</p>
  <div class="close" (click)="cancel()"><i class="fa fa-remove"></i></div>
  <form [formGroup]="remindForm" >
      <div class="form-group">
          <input type="email" (change)="isShowErrorLoginAndPassword = false" name="email"
                  [(ngModel)]="userInf.email"
                  class="input-field" id="{{id}}-click-email_field-input-popup_forgotpass-1"
                  formControlName="email"
                  placeholder="{{'user.signinup.enterEmail' | translate}}" [maxlength]="256" required="">
          <div class="error-field" *ngIf="(remindForm.get('email').invalid && remindForm.get('email').touched) || serverMessage">
              <span *ngIf="!serverMessage && remindForm.get('email')['errors']['pattern']">{{'user.signinup.emailPattern'  | translate}}</span>
              <span *ngIf="serverMessage">{{serverMessage | translate}}</span>
          </div>
      </div>
      <button (click)="execute()"  id="{{id}}-click-send_password-button-popup_forgotpass-1" [ngClass]="{'loading': isDisabled}" [disabled]="remindForm.invalid || isDisabled"><p *ngIf="!isDisabled">{{'user.signinup.send' | translate}}</p><lz-preloader *ngIf="isDisabled"></lz-preloader></button>
      <div class="goAuth"><span (click)="goBackAuth()" id="{{id}}-click-to_login-link-popup_forgotpass-1">{{'user.signinup.signInNew' | translate}}</span></div>
  </form>
  <form [formGroup]="cFormGroup">
  <ngx-invisible-recaptcha hl="uk" #captchaRef (success)="remind($event)" siteKey="6LcfMkgUAAAAAOmzWe6krfV-cgR3MczaQVrqxUVR" formControlName="recaptcha"></ngx-invisible-recaptcha>
  </form>
</div>
`,
  styles: [`.lz-pl-container{position:relative;display:block;margin-left:auto;margin-right:auto;padding:0 12px}@media (min-width:758px){.lz-pl-container{width:732px;padding:0}}@media (min-width:1002px){.lz-pl-container{width:976px}}@media (min-width:1490px){.lz-pl-container{width:1440px}}.lz-pl-container-new{position:relative;display:block;margin-left:auto;margin-right:auto;padding:0 12px}@media (min-width:758px){.lz-pl-container-new{width:732px;padding:0}}@media (min-width:1200px){.lz-pl-container-new{width:1200px}}@media (min-width:1490px){.lz-pl-container-new{width:1440px}}.modal-lg{width:900px}*,:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box}*{text-shadow:none!important;margin:0;padding:0}body,h1,h2,h3,h4,h5,h6,ol,p,ul{margin:0;padding:0;font-weight:400}ol,ul{list-style:none}img{max-width:100%;height:auto;vertical-align:middle}.h1,.h2,.h3,.h4,.h5,.h6,button,h1,h2,h3,h4,h5,h6,input,p,textarea{font-family:inherit;font-size:inherit;font-weight:inherit}input:focus,textarea:focus{outline:0}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{line-height:1.1}fieldset{border:none}::ng-deep .cdk-global-scrollblock{position:static!important;overflow:hidden}::ng-deep .cdk-global-scrollblock body{overflow:hidden}::ng-deep .cdk-overlay-backdrop{background:rgba(0,0,0,.588)}::ng-deep .cdk-overlay-container .myPane .mat-dialog-container{margin:0;max-height:95vh;border-radius:0;background:rgba(0,0,0,0);-webkit-box-shadow:none;box-shadow:none;padding:0;overflow:visible;font-family:Geometria,sans-serif;font-weight:400}@media (max-width:1279px){::ng-deep .cdk-overlay-container .myPane .mat-dialog-container{overflow-x:hidden}}@media (max-width:758px){::ng-deep .cdk-overlay-container .myPane{max-width:450px!important}::ng-deep .cdk-overlay-container .myPane .mat-dialog-container{max-width:450px}}input:-webkit-autofill,input:-webkit-autofill:focus,input:-webkit-autofill:hover{border:0;-webkit-text-fill-color:#fff;-webkit-box-shadow:0 0 0 1000px transparent inset;box-shadow:0 0 0 1000px transparent inset;-webkit-transition:background-color 5000s ease-in-out;transition:background-color 5000s ease-in-out;background:-webkit-linear-gradient(top,rgba(255,255,255,0) 0,rgba(0,174,255,.04) 50%,rgba(255,255,255,0) 51%,rgba(0,174,255,.03) 100%)}.remind{padding:50px 30px 30px;width:370px;max-width:100%;background:-webkit-gradient(linear,left bottom,left top,from(#3b60f7),to(#2741b0));background:linear-gradient(0deg,#3b60f7 0,#2741b0 100%);font-family:Geometria,sans-serif;font-weight:400;position:relative}.remind .lz-logo{position:absolute;top:0;left:0}.remind .lz-logo img{width:120%}.remind h1{color:#fff;font-size:36px;margin-bottom:20px;font-weight:700}.remind .close{position:absolute;border:1px solid #727dc7;color:#727dc7;right:20px;top:20px;width:35px;padding:5px;text-align:center;cursor:pointer}@media (max-width:321px){.remind .close{right:45px}}.remind .remind-pass-email{color:#fff;font-size:18px;margin-bottom:15px;font-weight:400;opacity:.5}.remind .form-group{position:relative}.remind .form-group .error-required{font-style:normal;font-weight:400;color:#ff564e;position:absolute;top:8px;left:0;z-index:0;font-size:14px;cursor:text}.remind .form-group .error-field{position:absolute;color:#fff;background-color:#ff564e;font-size:12px;top:25px;width:100%;z-index:0}.remind .form-group .error-field span{display:table;margin:3px;line-height:1}.remind .form-label{width:100%;color:#fff;font-weight:bolder;font-size:14px;opacity:0}.remind .input-field{background-color:rgba(0,0,0,0);color:#fff;border:none;border-bottom:1px solid #fff;width:100%;height:30px;z-index:1;margin-bottom:30px}.remind .input-field#name{margin-bottom:10px}.remind .input-field.ng-invalid.ng-touched{border-bottom:1px solid #ff564e;color:#ff564e}.remind .input-field:focus{border-bottom:1px solid #ffbe26}.remind .input-field::-webkit-input-placeholder{font-style:normal;font-weight:400;color:#fff;z-index:-10}.remind .input-field::-ms-input-placeholder{font-style:normal;font-weight:400;color:#fff;z-index:-10}.remind .input-field::placeholder{font-style:normal;font-weight:400;color:#fff;z-index:-10}.remind .input-field.ng-invalid.ng-touched::-webkit-input-placeholder{color:#ff564e}.remind .input-field.ng-invalid.ng-touched::-ms-input-placeholder{color:#ff564e}.remind .input-field.ng-invalid.ng-touched::placeholder{color:#ff564e}.remind .input-field:focus::-webkit-input-placeholder{opacity:.5}.remind .input-field:focus::-ms-input-placeholder{opacity:.5}.remind .input-field:focus::placeholder{opacity:.5}.remind button{width:100%;background-color:#ffbe26;color:#303f9f;text-transform:uppercase;padding:15px;border:none;font-size:17px;font-weight:800;margin-bottom:15px;letter-spacing:1px;display:flex;display:-webkit-box;display:-ms-flexbox;justify-content:center;-webkit-box-pack:center;-ms-flex-pack:center;text-align:-webkit-center;text-align:-moz-center;cursor:pointer}.remind button p{width:100%}.remind button.loading{padding:24.5px}.remind .goAuth{color:#ffbe26;text-transform:uppercase;text-align:center;font-size:14px;font-weight:700;letter-spacing:1px}.remind .goAuth span{cursor:pointer}`]
})

export class LzRemindNewComponent implements OnInit, OnDestroy {

  @ViewChild(InvisibleReCaptchaComponent) captcha: InvisibleReCaptchaComponent;
  private lang;

  public reg;
  public remindForm: FormGroup;
  public cFormGroup: FormGroup;
  public isDisabled = false;
  public userInf: any;
  public isShowErrorLoginAndPassword;
  public message;
  public success;
  public data;
  public serverMessage = '';
  public resolved(captchaResponse: string) {};
  public submitted = false;
  public id;
  EMAIL_REGEXP = /^[a-z0-9._-]+@[a-z0-9._-]+\.[a-z0-9]{2,}$/i;
  private config;
  private sub0: Subscription;
  private sub1: Subscription;
  private sub2: Subscription;
  private needToDisable = true;

  constructor(private language: LzLanguageService,
    public dialogRef: MatDialogRef < LzRemindNewComponent > ,
    public dialog: MatDialog,
    private http: CustomRequestService,
    @Inject(MAT_DIALOG_DATA) public info: any,
    @Inject(DOCUMENT) private document: any,
    private translate: TranslateService,
    private lzProductConfig: LzProductConfig
  ) {
    this.userInf = this.info.info;
    this.lang = this.language.identifyLanguage();
    this.config = lzProductConfig.getProductSettings();
    this.id = this.config['order_code'] || 'platforma';

  }



  ngOnInit() {

    this.remindForm = new FormGroup({
      'email': new FormControl(null, [Validators.required, Validators.pattern(this.EMAIL_REGEXP)]),
    });
    this.cFormGroup = new FormGroup({
      'recaptcha': new FormControl(null, [Validators.required])
    });
    this.watchErrorRequired();
  }

  goBackAuth = () => {
    let alias = '';
    if (this.info && this.info.alias) {
      alias = this.info.alias;
    }
    this.dialogRef.close();
    this.info.showAuth(false, alias);
  };

  execute() {
    this.isDisabled = true;
    this.submitted = true;


    this.captcha.execute();
    setTimeout(() => {
      if (this.needToDisable == true) {
        this.isDisabled = false
      }

    }, 5000);


  }
  remind = (captchaResponse: string) => {
    this.needToDisable = false;
    this.isDisabled = true;
    let par = {
      email: this.userInf.email,
      'g-recaptcha-response': captchaResponse,
      "Accept-Language": this.lang
    };

    this.sub0 = this.http.postRequestWithFormData(this.lzProductConfig.getApiLink() + '/lz-platforma/auth/v2.0/registration/remindPassword',
        par, {}, {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        })
      .subscribe((msg) => {
          if (!msg.isOk == true) {
            this.captcha.resetCaptcha();
            try {
              grecaptcha.reset();
            } catch(e) { }
            this.isDisabled = false;
            if (msg.code == 500) {
              this.serverMessage = 'Something went wrong';
            } else {
              this.serverMessage = msg.message.login;
            }
          } else {
            if (!window['dataLayer']) {
              window['dataLayer'] = [];
            }
            window['dataLayer'].push({
              'event': 'autoEvent',
              'eventCategory': 'forgot_password',
              'eventAction': this.id,
              'eventLabel': window.location.href
            });
            this.dialogRef.close();
            this.info.showWelc(this.userInf.email, 'remindForm');
          }
        },
        (error) => {
          this.isDisabled = false;
          this.serverMessage = 'user.signinup.error';
          this.captcha.resetCaptcha();
          try {
            grecaptcha.reset();
          } catch(e) { }
          setTimeout(() => {
            this.serverMessage = ''
          }, 5000);
        });

  };

  cancel = () => {
    this.dialogRef.close();
  };



  watchErrorRequired() {
    let values: Observable < number > = interval(100);

    let emailRequired: string;

    let cptchwrppr: any;
    let cptch: any;
    let body: any = document.body;

    this.translate.get('user.signinup.emailRequired').subscribe(trans => emailRequired = trans);

    this.sub2 = values.subscribe(() => {

      if (this.remindForm.get('email').invalid && this.remindForm.get('email').touched &&
        this.remindForm.get('email')['errors']['required']) {
        $('#e-mail').attr('placeholder', emailRequired);

      }

      if (this.userInf.email.indexOf(' ') != -1) {
        this.userInf.email = this.userInf.email.replace(' ', '');
      }
      if (this.submitted) {

        if (cptchwrppr != $(body).children('div')[$(body).children('div').length - 1]) {
          cptchwrppr = $(body).children('div')[$(body).children('div').length - 1];
        }
        cptch = $(cptchwrppr).children('div')[1];
        $(cptch).css('position', 'fixed');

      }
    });
    this.sub1 = this.remindForm.valueChanges.subscribe(() => {
      if (this.serverMessage) {
        this.serverMessage = '';
      }
    })
  }

  ngOnDestroy() {
    if (this.sub0) {
      this.sub0.unsubscribe();
    }
    if (this.sub1) {
      this.sub1.unsubscribe();
    }
    this.sub2.unsubscribe();

  }

}
